/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
/**
 * Enumerates different calculation modes for summaries in the data source.
 */
export var DataSourceSummaryScope = /*@__PURE__*/ (function (DataSourceSummaryScope) {
    /**
     * Summaries are calculated for both the root and section level.
     */
    DataSourceSummaryScope[DataSourceSummaryScope["Both"] = 0] = "Both";
    /**
     * Summaries are only calculated at the root level.
     */
    DataSourceSummaryScope[DataSourceSummaryScope["Root"] = 1] = "Root";
    /**
     * Summaries are only calculated at the group level.
     */
    DataSourceSummaryScope[DataSourceSummaryScope["Groups"] = 2] = "Groups";
    /**
     * Summaries are not calculated at all.
     */
    DataSourceSummaryScope[DataSourceSummaryScope["None"] = 3] = "None";
    return DataSourceSummaryScope;
})({});
/**
 * @hidden
 */
export var DataSourceSummaryScope_$type = /*@__PURE__*/ markEnum('DataSourceSummaryScope', 'Both,0|Root,1|Groups,2|None,3');
//# sourceMappingURL=DataSourceSummaryScope.js.map
